import React from "react";
import { navigate, RouteComponentProps, useLocation } from "@reach/router";
import { IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip } from "@material-ui/core";
import { Person, Language, ContactMail, Description, Add, FolderOpen } from "@material-ui/icons";
import Development from "components/development";
import { authorizeForRole } from "components/auth/authorize-for-role";
import { Roles, Viewer } from "components/auth/types";
import { useFeature } from "components/feature";
import {
  Feature,
} from "types/gql-types";
import ListsSidebar from "./lists-sidebar";


const SETTINGS_PAGES = [
  {
    name: "Organization",
    icon: "fa-globe",
    path: "organization",
    supervisor: true,
    released: true,
  },
  {
    name: "Team",
    icon: "fa-user",
    path: "team",
    supervisor: true,
    released: true,
  },
  {
    name: "Schedule List Update",
    icon: "fa-envelope",
    path: "scheduled-updates",
    supervisor: true,
    released: true,
  },
  {
    name: "Imports",
    icon: "fa-folder-open",
    path: "imports/upload",
    supervisor: false,
    released: Feature.IMPORTS,
  },
  {
    name: "Templates",
    icon: "fa-file",
    path: "templates",
    supervisor: false,
    released: true,
  },
] as const;

const icons = {
  "fa-globe": Language,
  "fa-user": Person,
  "fa-envelope": ContactMail,
  "fa-file": Description,
  "fa-folder-open": FolderOpen,
} as const;

interface NavLinkProps {
  path: string;
  icon: keyof typeof icons;
  text: string;
}

const NavLink = (props: NavLinkProps) => {
  const location = useLocation();
  const Icon = icons[props.icon];
  const href = `/dash/manager/settings/${props.path}`;
  return (
    <MenuItem href={href} selected={!!location.pathname.includes(props.path)} dense
      onClick={(e) => {
        e.preventDefault();
        navigate(href);
      }}
    >
      <ListItemIcon style={{ minWidth: "36px" }}>
        <Icon />
      </ListItemIcon>
      <ListItemText>
        {props.text}
      </ListItemText>
    </MenuItem>
  );
};

const Sidebar: React.FC<RouteComponentProps<{viewer: Viewer}>> = (props) => {
  const buildingsEnabled = useFeature(Feature.BUILDING_SETTINGS);
  const importsEnabled = useFeature(Feature.IMPORTS);
  return (
    <div>
      <h1>Settings</h1>
      <Development>
        {(development) => SETTINGS_PAGES.map((attrs) => {
          const isAuthorized = attrs.supervisor === false || props.viewer?.isSupervisor;
          const isReleased = attrs.released === true || development || (attrs.released === Feature.IMPORTS && importsEnabled);
          return (
            isAuthorized &&
                isReleased && (
              <NavLink
                key={attrs.name}
                text={attrs.name}
                icon={attrs.icon}
                path={attrs.path}
              />
            )
          );
        })}
      </Development>

      {
        props.viewer && <div>
          <h5>Properties {props.viewer?.isSupervisor && buildingsEnabled && (
            <Tooltip title="Add" placement="right">
              <IconButton
                size="small"
                onClick={() => navigate("/dash/manager/settings/property/new")}>
                <Add />
              </IconButton>
            </Tooltip>)}
          </h5>
          <ListsSidebar viewer={props.viewer} />
        </div>
      }

    </div>
  );
};

export default authorizeForRole([Roles.PropertyManager], Sidebar);
